import React, { Component } from "react";
import "components/Common/Clauses/Base/style.scss";

class Clause extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { clause, canDeleteClause, deleteClause, className } = this.props;

    const onClick = canDeleteClause ? () => deleteClause(clause.id) : () => {};

    return (
      <div className={`clause ${className}`}>
        {this.props.children}
        {canDeleteClause && (
          <div className="delete-clause">
            <a
              className={`${canDeleteClause ? "enabled" : "disabled"}`}
              onClick={onClick}
            >
              <i className="fas fa-trash-alt" />
            </a>
          </div>
        )}
      </div>
    );
  }
}

export default Clause;
